module.exports = __webpack_public_path__ + "static/minnanobousai_gmail-11ddc3b4e25d5f2f8b4563435b03db79.png";